import { useState } from 'react'
import { guestService } from '@/services'

export const useConfirmGuestAppointment = () => {
  const [loadingConfirmGuestAppointment, setLoadingConfirmGuestAppointment] =
    useState(false)

  const confirmGuestAppointment = async payload => {
    setLoadingConfirmGuestAppointment(true)
    try {
      const response = await guestService.confirmGuestAppointment(payload)
      return response
    } finally {
      setLoadingConfirmGuestAppointment(false)
    }
  }
  return { loadingConfirmGuestAppointment, confirmGuestAppointment }
}
